(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sawmah-pants-edit"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sawmah-pants-edit')){
 customElements.define('sawmah-pants-edit',class extends HTMLElement{
  connectedCallback(){
   if(this.shadowRoot)return;
   const template=this.querySelector('[data-pants-template]');if(!template)return;
   this.attachShadow({mode:'open'}).append(template.content.cloneNode(true));
   const document=this.shadowRoot;const config=JSON.parse(document.querySelector('[data-pants-config]').textContent);const lang=['fr','en','de'].includes(config.locale)?config.locale:'en';const root=config.root.endsWith('/')?config.root:config.root+'/';const t=Object.fromEntries(Object.entries(config.copy).map(([k,v])=>[k,new DOMParser().parseFromString(v,'text/html').body.textContent]));t.rows=Array.from({length:4},(_,r)=>Array.from({length:3},(_,c)=>t['row_'+r+'_'+c]));const purchaseCopy=Object.fromEntries(Object.entries(t).filter(([k])=>k.startsWith('purchase_')).map(([k,v])=>[k.slice(9),v]));
   const localIcons=(()=>{const nodes={"arrow-down-right":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["path",{"d":"m7 7 10 10"}],["path",{"d":"M17 7v10H7"}]]],"columns-2":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["rect",{"width":"18","height":"18","x":"3","y":"3","rx":"2"}],["path",{"d":"M12 3v18"}]]],"plus":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["path",{"d":"M5 12h14"}],["path",{"d":"M12 5v14"}]]],"arrow-up-right":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["path",{"d":"M7 7h10v10"}],["path",{"d":"M7 17 17 7"}]]],"x":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["path",{"d":"M18 6 6 18"}],["path",{"d":"m6 6 12 12"}]]],"arrow-left":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["path",{"d":"m12 19-7-7 7-7"}],["path",{"d":"M19 12H5"}]]],"arrow-right":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["path",{"d":"M5 12h14"}],["path",{"d":"m12 5 7 7-7 7"}]]],"maximize-2":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["polyline",{"points":"15 3 21 3 21 9"}],["polyline",{"points":"9 21 3 21 3 15"}],["line",{"x1":"21","x2":"14","y1":"3","y2":"10"}],["line",{"x1":"3","x2":"10","y1":"21","y2":"14"}]]],"monitor":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["rect",{"width":"20","height":"14","x":"2","y":"3","rx":"2"}],["line",{"x1":"8","x2":"16","y1":"21","y2":"21"}],["line",{"x1":"12","x2":"12","y1":"17","y2":"21"}]]],"smartphone":["svg",{"xmlns":"http://www.w3.org/2000/svg","width":24,"height":24,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":2,"stroke-linecap":"round","stroke-linejoin":"round"},[["rect",{"width":"14","height":"20","x":"5","y":"2","rx":"2","ry":"2"}],["path",{"d":"M12 18h.01"}]]]};
function element([tag,attrs={},children=[]]){const e=window.document.createElementNS('http://www.w3.org/2000/svg',tag);Object.entries(attrs).forEach(([k,v])=>e.setAttribute(k,v));children.forEach(c=>e.appendChild(element(c)));return e;}
return {createIcons(){document.querySelectorAll('[data-lucide]').forEach(el=>{const node=nodes[el.dataset.lucide];if(!node)return;const svg=element(node);svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');if(el.className)svg.setAttribute('class',el.className);el.replaceWith(svg);});}};})();
   const colors={Ciel:'#a9c4da',Marine:'#263749','Black Intense':'#202020',Figue:'#62525f','Gris Clair':'#c0c0bc',Blanc:'#fafafa',Noir:'#171717',Amande:'#969987','Bleu Pastel':'#879dad'};
const translatedColors={en:{Ciel:'Sky blue',Marine:'Navy',Figue:'Fig','Gris Clair':'Light grey',Blanc:'White',Noir:'Black',Amande:'Almond','Bleu Pastel':'Pastel blue'},de:{Ciel:'Himmelblau',Marine:'Marineblau',Figue:'Feige','Gris Clair':'Hellgrau',Blanc:'Weiß',Noir:'Schwarz',Amande:'Mandel','Bleu Pastel':'Pastellblau'}};
const colorName=p=>translatedColors[lang]?.[p.color]||p.color;
const displayTitle=p=>`${p.family==='jazan'?t.cargo:t.jogging} · ${colorName(p)}`;
const money=n=>new Intl.NumberFormat(lang==='en'?'en-IE':lang==='de'?'de-DE':'fr-FR',{style:'currency',currency:config.currency||'EUR'}).format(n);
const order={jazan:['Ciel','Black Intense','Marine'],yusr:['Figue','Gris Clair','Blanc','Noir','Amande','Bleu Pastel']};
const families={jazan:config.products.filter(p=>p.family==='jazan'),yusr:config.products.filter(p=>p.family==='yusr')};
if(!families.jazan.length||!families.yusr.length)return;
const state={jazan:{color:0,photo:0,variant:null},yusr:{color:0,photo:0,variant:null}};
const current=k=>families[k][state[k].color];
const photoSizes='(max-width:360px) calc(100vw - 28px), (max-width:700px) calc(100vw - 36px), (max-width:900px) calc(50vw - 38px), (max-width:1280px) calc(50vw - 62px), 578px';
const photoSources=photo=>[480,750,1100,1400].map(width=>{const url=new URL(photo.url,window.location.origin);url.searchParams.set('width',width);return `${url.href} ${width}w`;}).join(', ');
const preparedPhotos=new Map();
function preparePhoto(photo,fullSize=false){
  const key=(fullSize?'full:':'card:')+photo.url;
  if(preparedPhotos.has(key))return;
  const image=new Image();
  image.decoding='async';image.fetchPriority='low';
  if(!fullSize){image.sizes=photoSizes;image.srcset=photoSources(photo);}
  image.src=photo.url;
  preparedPhotos.set(key,image);
  image.onerror=()=>preparedPhotos.delete(key);
  if(preparedPhotos.size>24)preparedPhotos.delete(preparedPhotos.keys().next().value);
}
function prepareNearby(k,fullSize=false){
  const panel=document.querySelector('#panel-'+k);
  if(!fullSize&&!panel.getClientRects().length)return;
  const connection=navigator.connection;
  if(connection?.saveData||/2g/.test(connection?.effectiveType||''))return;
  const p=current(k),index=state[k].photo;
  [1,2].forEach(offset=>preparePhoto(p.images[(index+offset)%p.images.length],fullSize));
}
const route=p=>p.url;
const icon=name=>`<i data-lucide="${name}"></i>`;
const refreshIcons=()=>localIcons.createIcons();
function renderSizes(k){
  const p=current(k);
  return p.variants.map(v=>`<label class="inline-size" title="${v.size}${v.available?'':' · '+t.unavailable}"><input type="radio" name="size-${k}" value="${v.id}" ${state[k].variant===v.id?'checked':''} ${v.available?'':'disabled'} aria-label="${v.size}${v.available?'':' · '+t.unavailable}"><span>${v.size}</span></label>`).join('');
}

document.querySelector('[role=tablist]').setAttribute('aria-label',t.title);
document.querySelectorAll('[data-t]').forEach(n=>n.textContent=t[n.dataset.t]);
document.querySelector('.compare-shortcut').href=config.guide;
document.querySelector('.closing a').href=root+'collections/streetwear';
document.querySelectorAll('button.close').forEach(n=>{n.setAttribute('aria-label',t.close);n.title=t.close;});
document.querySelector('#gallery-prev').setAttribute('aria-label',t.previous);
document.querySelector('#gallery-next').setAttribute('aria-label',t.next);
document.querySelector('#compare-body').innerHTML=t.rows.map(row=>`<tr>${row.map((cell,i)=>i?`<td>${cell}</td>`:`<th scope="row">${cell}</th>`).join('')}</tr>`).join('');
function renderProduct(k){
  const p=current(k),s=state[k],family=families[k];
  return `<article class="product" id="panel-${k}" data-key="${k}" data-active="${k==='jazan'}" aria-label="${k==='jazan'?t.cargo:t.jogging}">
  <div class="product-top"><span>${t[k+'Tag']}</span><span class="index">${k==='jazan'?'01':'02'} / 02</span></div>
  <div class="photo-wrap"><button class="photo-button" data-action="gallery" aria-label="${t.expand} · ${p.title}"><img sizes="${photoSizes}" srcset="${photoSources(p.images[s.photo])}" src="${p.images[s.photo].url}" alt="${p.title}" width="900" height="1000" loading="lazy" decoding="async"></button><span class="photo-count">01 / ${String(p.images.length).padStart(2,'0')}</span><div class="photo-tools"><button class="icon" data-action="gallery" aria-label="${t.expand}" title="${t.expand}">${icon('maximize-2')}</button><button class="icon" data-action="next" aria-label="${t.next}" title="${t.next}">${icon('arrow-right')}</button></div></div>
  <div class="product-info"><div class="name-line"><h2>${k==='jazan'?t.cargo:t.jogging}</h2><span class="price">${money(p.price)}</span></div><p class="description">${t[k+'Desc']}</p>
  <div class="color-row"><div class="swatches" role="group" aria-label="${k==='jazan'?t.cargo:t.jogging} · ${t.colors}">${family.map((c,i)=>`<button class="swatch" data-color="${i}" aria-label="${colorName(c)}" aria-pressed="${i===s.color}" style="--swatch:${colors[c.color]}"><span class="swatch-dot"></span><span class="tip" aria-hidden="true">${colorName(c)}</span></button>`).join('')}</div><p class="color-name" aria-live="polite"><span>${colorName(p)}</span><small>${family.length} ${t.colors}</small></p></div>
  <div class="purchase"><fieldset class="inline-sizes"><legend><span>${purchaseCopy.size}</span><span class="selection-note" aria-live="polite">${purchaseCopy.select}</span></legend><div class="inline-size-grid">${renderSizes(k)}</div></fieldset><button class="add-to-cart" data-action="add" disabled><span class="add-label">${icon('plus')}<span>${purchaseCopy.add}</span></span><span class="add-price">${money(p.price)}</span></button><p class="purchase-status" role="status"></p></div></div></article>`;
}
document.querySelector('#duo').innerHTML=['jazan','yusr'].map(renderProduct).join('');
function update(k){
  const p=current(k),s=state[k],panel=document.querySelector('#panel-'+k),img=panel.querySelector('.photo-button img');
  const photo=p.images[s.photo];
  if(img.dataset.photo!==photo.url){
    img.sizes=photoSizes;img.srcset=photoSources(photo);img.src=photo.url;
    img.dataset.photo=photo.url;
  }
  img.alt=displayTitle(p);
  if(panel.getBoundingClientRect().top<window.innerHeight+200&&panel.getBoundingClientRect().bottom>0)prepareNearby(k);
  panel.querySelector('.photo-button').setAttribute('aria-label',`${t.expand} · ${displayTitle(p)}`);
  panel.querySelector('.photo-count').textContent=`${String(s.photo+1).padStart(2,'0')} / ${String(p.images.length).padStart(2,'0')}`;
  panel.querySelector('.price').textContent=money(p.price);
  panel.querySelector('.color-name span').textContent=colorName(p);
  panel.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',Number(b.dataset.color)===s.color));
}
function updatePurchase(k,resetSizes=false){
  const panel=document.querySelector('#panel-'+k),p=current(k);
  const variant=p.variants.find(v=>v.id===state[k].variant&&v.available);
  if(resetSizes)panel.querySelector('.inline-size-grid').innerHTML=renderSizes(k);
  panel.querySelector('.selection-note').textContent=variant?`${variant.size} · ${purchaseCopy.available}`:purchaseCopy.select;
  const button=panel.querySelector('.add-to-cart');
  button.disabled=!variant;
  button.classList.remove('is-added');
  button.querySelector('.add-label span').textContent=purchaseCopy.add;
  button.querySelector('.add-price').textContent=money(p.price);
  panel.querySelector('.purchase-status').textContent='';
}
let galleryFamily='jazan';
function updateGallery(){const p=current(galleryFamily),s=state[galleryFamily];document.querySelector('#gallery-title').textContent=`${galleryFamily==='jazan'?t.cargo:t.jogging} · ${colorName(p)}`;const img=document.querySelector('#gallery-image');img.src=p.images[s.photo].url;img.alt=`${p.title} · ${t.photo} ${s.photo+1}`;document.querySelector('#gallery-counter').textContent=`${s.photo+1} / ${p.images.length}`;prepareNearby(galleryFamily,true);}
document.querySelector('#duo').addEventListener('change',e=>{
  if(!e.target.matches('.inline-size input'))return;
  const k=e.target.closest('.product').dataset.key;
  state[k].variant=e.target.value;
  updatePurchase(k);
});
document.querySelector('#duo').addEventListener('click',async e=>{
  const panel=e.target.closest('.product'),b=e.target.closest('button');
  if(!panel||!b)return;
  const k=panel.dataset.key;
  if(state[k].busy)return;
  if(b.hasAttribute('data-color')){
    state[k]={color:Number(b.dataset.color),photo:0,variant:null};
    update(k);updatePurchase(k,true);
  }
  if(b.dataset.action==='next'){
    state[k].photo=(state[k].photo+1)%current(k).images.length;update(k);
  }
  if(b.dataset.action==='gallery'){
    galleryFamily=k;updateGallery();document.querySelector('#gallery-dialog').showModal();
  }
  if(b.dataset.action==='add'){
    const variant=current(k).variants.find(v=>v.id===state[k].variant&&v.available);
    if(!variant)return;
    state[k].busy=true;
    b.disabled=true;b.setAttribute('aria-busy','true');
    panel.querySelector('fieldset').disabled=true;
    panel.querySelectorAll('[data-color]').forEach(el=>el.disabled=true);
    b.querySelector('.add-label span').textContent=t.loading;
    const status=panel.querySelector('.purchase-status');status.textContent='';
    try{
      const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}],sections:['cart-drawer','cart-bubble','main-cart'],sections_url:window.location.pathname})});
      const result=await response.json();
      if(!response.ok||result.status){throw new Error(result.description||t.error);}
      b.classList.add('is-added');b.querySelector('.add-label span').textContent=purchaseCopy.added;
      const link=window.document.createElement('a');link.href=root+'cart';link.textContent=t.cart;status.replaceChildren(link);
      try{
        for(const [id,section,selector] of [['Cart-Drawer','cart-drawer','.cart-drawer'],['cart-drawer-toggle','cart-bubble','.thb-item-count'],['Cart','main-cart','.thb-cart-form']]){
          const host=window.document.getElementById(id),markup=result.sections?.[section];
          if(!host||!markup)continue;
          const replacement=new DOMParser().parseFromString(markup,'text/html').querySelector(selector);
          if(replacement)(host.querySelector(selector)||host).innerHTML=replacement.innerHTML;
        }
        const drawer=window.document.getElementById('Cart-Drawer');
        if(drawer&&typeof OverlayManager!=='undefined'){
          OverlayManager.open(drawer);
          window.document.dispatchEvent(new CustomEvent('cart-drawer:open',{bubbles:true}));
        }
      }catch(renderError){window.document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));}
      window.document.dispatchEvent(new CustomEvent('cart:item-added',{bubbles:true,detail:{product:result.items?.[0]||result}}));
    }catch(error){status.textContent=error.message||t.error;b.querySelector('.add-label span').textContent=purchaseCopy.add;}
    finally{state[k].busy=false;b.disabled=false;b.removeAttribute('aria-busy');panel.querySelector('fieldset').disabled=false;panel.querySelectorAll('[data-color]').forEach(el=>el.disabled=false);}
  }
});
document.querySelectorAll('[role=tab]').forEach(b=>{b.addEventListener('click',()=>{document.querySelectorAll('[role=tab]').forEach(tab=>{tab.setAttribute('aria-selected',tab===b);tab.tabIndex=tab===b?0:-1;});document.querySelectorAll('.product').forEach(p=>p.dataset.active=p.dataset.key===b.dataset.family);});b.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const tabs=[...document.querySelectorAll('[role=tab]')];const target=e.key==='Home'?tabs[0]:e.key==='End'?tabs[1]:tabs.find(tab=>tab!==b);target.click();target.focus();}});});
document.querySelector('#tab-yusr').tabIndex=-1;
document.querySelector('#gallery-prev').addEventListener('click',()=>{const s=state[galleryFamily];s.photo=(s.photo-1+current(galleryFamily).images.length)%current(galleryFamily).images.length;updateGallery();update(galleryFamily);});
document.querySelector('#gallery-next').addEventListener('click',()=>{state[galleryFamily].photo=(state[galleryFamily].photo+1)%current(galleryFamily).images.length;updateGallery();update(galleryFamily);});
document.querySelectorAll('dialog').forEach(d=>d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)d.close();}}));
function syncPanels(){
  const mobile=matchMedia('(max-width:700px)').matches;
  document.querySelectorAll('.product').forEach(panel=>{
    panel.setAttribute('role',mobile?'tabpanel':'article');
    if(mobile)panel.setAttribute('aria-labelledby','tab-'+panel.dataset.key);
    else panel.removeAttribute('aria-labelledby');
  });
}
this.mobile=matchMedia('(max-width:700px)');this.syncPanels=syncPanels;this.mobile.addEventListener('change',syncPanels);
syncPanels();
['jazan','yusr'].forEach(update);
this.photoObserver=new IntersectionObserver(entries=>{
  entries.forEach(entry=>{if(entry.isIntersecting)prepareNearby(entry.target.dataset.key);});
},{rootMargin:'200px'});
document.querySelectorAll('.product').forEach(panel=>{
  this.photoObserver.observe(panel);
  panel.querySelector('.photo-button img').addEventListener('load',()=>{
    const rect=panel.getBoundingClientRect();
    if(rect.top<window.innerHeight+200&&rect.bottom>0)prepareNearby(panel.dataset.key);
  });
});
refreshIcons();

  }
  disconnectedCallback(){this.mobile?.removeEventListener('change',this.syncPanels);this.photoObserver?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sawmah-qamis-edit"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sawmah-qamis-edit')) {
    customElements.define('sawmah-qamis-edit', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const tabs = [...this.querySelectorAll('[data-sqe-tab]')];
        const panels = [...this.querySelectorAll('[data-sqe-panel]')];
        const tablist = this.querySelector('.sqe__tabs');
        const mobile = matchMedia('(max-width: 767px)');
        let selected = panels.findIndex(panel => Number(panel.dataset.sqeCount) > 0);
        if (selected < 0) selected = 0;
        const select = (index) => {
          selected = index;
          tabs.forEach((tab, i) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', panels[i].id);
            tab.setAttribute('aria-selected', String(i === selected));
            tab.tabIndex = i === selected ? 0 : -1;
            panels[i].hidden = mobile.matches && i !== selected;
            if (mobile.matches && panels.length > 1) {
              panels[i].setAttribute('role', 'tabpanel');
              panels[i].setAttribute('aria-labelledby', tab.id);
            } else {
              panels[i].removeAttribute('role');
              panels[i].removeAttribute('aria-labelledby');
            }
          });
          tablist.hidden = !mobile.matches || panels.length < 2;
        };
        tablist.setAttribute('role', 'tablist');
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(index), options);
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const target = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (selected + 1) % tabs.length;
            select(target);
            tabs[target].focus();
          }, options);
        });
        mobile.addEventListener('change', () => select(selected), options);
        select(selected);
        this.observers = [];
        panels.forEach(panel => {
          const rail = panel.querySelector('.sqe__rail');
          if (!rail) return;
          const slides = [...rail.querySelectorAll('[data-sqe-slide]')];
          const swatches = [...panel.querySelectorAll('[data-sqe-index]')];
          const prev = panel.querySelector('[data-sqe-prev]');
          const next = panel.querySelector('[data-sqe-next]');
          let active = 0;
          const mark = index => {
            active = index;
            swatches.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
            slides.forEach((slide, i) => { slide.inert = i !== active; });
            prev.disabled = active === 0;
            next.disabled = active === slides.length - 1;
            panel.querySelector('[data-sqe-position]').textContent = String(active + 1);
          };
          const go = index => {
            const slide = slides[Math.max(0, Math.min(index, slides.length - 1))];
            rail.scrollBy({ left: slide.getBoundingClientRect().left - rail.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          };
          swatches.forEach((button, i) => button.addEventListener('click', () => go(i), options));
          prev.addEventListener('click', () => go(active - 1), options);
          next.addEventListener('click', () => go(active + 1), options);
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) mark(slides.indexOf(entry.target));
            });
          }, { root: rail, threshold: 0.6 });
          slides.forEach(slide => observer.observe(slide));
          this.observers.push(observer);
          panel.querySelector('.sqe__controls').hidden = slides.length < 2;
          mark(0);
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observers?.forEach(observer => observer.disconnect());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
